import { useAiDemoEmailDomainAccess } from './use-ai-demo-email-domain-access';
import { useAiAssistantAvailability } from './use-ai-assistant-availability';
import { useAiRolePermissions } from './use-ai-role-permissions';

export function useAiAssistantVisibility() {
  const { aiFasitAssistant, aiCitizenAssistant } = useAiAssistantAvailability();
  const { isAiDemoEmailDomainAllowed } = useAiDemoEmailDomainAccess();
  const { isAiProductAllowed } = useAiRolePermissions();

  return {
    isFasitAssistantVisible: aiFasitAssistant.enabled && !aiFasitAssistant.restrictedToAdminPage && isAiDemoEmailDomainAllowed,
    isCitizenAssistantVisible: aiCitizenAssistant.enabled && !aiCitizenAssistant.restrictedToAdminPage && isAiProductAllowed('summa') && isAiDemoEmailDomainAllowed,
  };
}
